import { type Dtos, type FileId, type SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { wipExtractionsQueryKey } from "../wip.keys";

export function useAdminExtractWipFile(accountId: SuretyAccountId) {
	const { post } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: async (fileId: FileId) => {
			const body: Dtos.Wip.Extraction.Create.Request = { fileId };
			return post(`/v2/admin/surety/accounts/${accountId}/wip-extractions`, body, "none");
		},
		onSuccess: async () => {
			await queryClient.invalidateQueries({ queryKey: wipExtractionsQueryKey(accountId) });
		},
	});

	return {
		extractWipFile: mutation.mutate,
		extractWipFilePending: mutation.isPending,
		extractWipFileError: mutation.error,
		dismissExtractWipFileError: () => {
			mutation.reset();
		},
	};
}
